/**
 * Channel Unread Class
 */
export class ChannelUnread {
    #collection;
    id;
    /**
     * Construct Channel
     * @param collection Collection
     * @param id Channel Id
     */
    constructor(collection, id) {
        this.#collection = collection;
        this.id = id;
    }
    /**
     * Whether this object exists
     */
    get $exists() {
        return !!this.#collection.getUnderlyingObject(this.id).id;
    }
    /**
     * Last read message id
     */
    get lastMessageId() {
        return this.#collection.getUnderlyingObject(this.id).lastMessageId;
    }
    /**
     * List of message IDs that we were mentioned in
     */
    get messageMentionIds() {
        return this.#collection.getUnderlyingObject(this.id).messageMentionIds;
    }
}
